import { Mapper } from '../../../mappers';
import { CustomerHealthDataType, CustomerHealth, CustomerHealthModule, CustomerHealthModuleIndex, CustomerHealthConditionIndex } from '../../../models';
import { CustomerHealth as OctopusCustomerHealth } from '../models/customer-health';

export class CustomerHealthMapper extends Mapper<OctopusCustomerHealth, CustomerHealth> {
  
  fromWithTranslations(
    source: OctopusCustomerHealth,
    translations: {
      salesTitle: string,
      salesRowLastContactedDate: string,
      csTitle: string,
      openCases: string,
      casesCreatedLastMonth: string,
      caseAgeExceeds: string,
      lastSupportResponse: string
    }
  ): CustomerHealth {
    const result = this.from(source);

    const salesModule = result.modules[CustomerHealthModuleIndex.Sales];
    salesModule.moduleName = translations.salesTitle;
    salesModule.conditions[CustomerHealthConditionIndex.LastContactedDate].description = translations.salesRowLastContactedDate;

    const csModule = result.modules[CustomerHealthModuleIndex.CustomerService];
    csModule.moduleName = translations.csTitle;
    csModule.conditions[CustomerHealthConditionIndex.OpenCases].description = translations.openCases;
    csModule.conditions[CustomerHealthConditionIndex.CasesCreatedLastMonth].description = translations.casesCreatedLastMonth;
    csModule.conditions[CustomerHealthConditionIndex.CaseAge].description = translations.caseAgeExceeds;
    csModule.conditions[CustomerHealthConditionIndex.LastSupportContact].description = translations.lastSupportResponse;

    return result;
  }
  
  from(source: OctopusCustomerHealth): CustomerHealth {
    return {
      numCases: -1,
      isEnable: source.DisplayCustomerHealthIndicator,
      modules: [
        {
          moduleName: '',
          conditions: [
            {
              dataType: CustomerHealthDataType.Day,
              dataValue: source.SalesLastContactedDateLimitInDays,
              dataWeight: source.SalesLastContactedDateWeight,
              description: ''
            }
          ]
        } as CustomerHealthModule,
        {
          moduleName: '',
          conditions: [
            {
              dataType: CustomerHealthDataType.Count,
              dataValue: source.CSOpenCasesLimit,
              dataWeight: source.CSOpenCasesWeight,
              description: ''
            },
            {
              dataType: CustomerHealthDataType.CountExceeds,
              dataValue: source.CSCasesCreatedLastMonthLimit,
              dataWeight: source.CSCasesCreatedLastMonthWeight,
              description: ''
            },
            {
              dataType: CustomerHealthDataType.Hour,
              dataValue: source.CSCaseAgeLimitInHours,
              dataWeight: source.CSCaseAgeWeight,
              description: ''
            },
            {
              dataType: CustomerHealthDataType.Hour,
              dataValue: source.CSLastSupportContactLimitInHours,
              dataWeight: source.CSLastSupportContactWeight,
              description: ''
            }
          ]
        } as CustomerHealthModule
      ]
    } as CustomerHealth;
  }
}
